import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const HomeFilledSVG = ({
  stroke = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <g clipPath="url(#clip0_279_12189)">
        <path
          d="M8.4 10.5619V13.2396C8.4 13.4413 8.47375 13.6347 8.60503 13.7773C8.7363 13.9199 8.91435 14 9.1 14H13.3C13.4857 14 13.6637 13.9199 13.795 13.7773C13.9262 13.6347 14 13.4413 14 13.2396V6.51764C14 6.35786 13.971 6.19965 13.9148 6.05203C13.8585 5.90441 13.776 5.77028 13.672 5.6573L7.791 0.356205C7.68717 0.243282 7.56386 0.1537 7.42814 0.0925798C7.29241 0.0314595 7.14693 0 7 0C6.85307 0 6.70759 0.0314595 6.57186 0.0925798C6.43614 0.1537 6.31283 0.243282 6.209 0.356205L0.328 5.6573C0.224001 5.77028 0.141507 5.90441 0.0852285 6.05203C0.0289501 6.19965 -1.06094e-05 6.35786 2.91551e-09 6.51764L2.91551e-09 13.2396C2.91551e-09 13.4413 0.0737498 13.6347 0.205025 13.7773C0.336301 13.9199 0.514348 14 0.7 14H4.9C5.08565 14 5.2637 13.9199 5.39497 13.7773C5.52625 13.6347 5.6 13.4413 5.6 13.2396V10.5619C5.6 10.1586 5.7475 9.77173 6.01005 9.48652C6.2726 9.20132 6.6287 9.04109 7 9.04109C7.3713 9.04109 7.7274 9.20132 7.98995 9.48652C8.2525 9.77173 8.4 10.1586 8.4 10.5619Z"
          stroke={stroke}
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_279_12189">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </span>
);

export default HomeFilledSVG;
